import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GuideAnchorDirective } from './core/directives/guide-anchor.directive';
import { GuideDriverAdapterService } from './core/services/guide-driver-adapter.service';

@NgModule({
  declarations: [GuideAnchorDirective],
  imports: [CommonModule],
  exports: [GuideAnchorDirective],
  providers: [GuideDriverAdapterService],
})
export class GuideModule {}
